import { useConsoleAccess } from './console-access';

/**
 * Paid reporting customers who have not started the PLG automation trial yet.
 * Used for “Explore automation” and “Start 30-day free trial” upsells.
 */
export const useShouldShowAutomationUpsell = (): boolean =>
  useConsoleAccess().showAutomationUpsell;
